import React from 'react';
import { Route, Routes } from 'react-router-dom';
import CommunityDetails from '../containers/CommunityDetails';
import CommunitiesOverview from '../components/CommunitiesOverview';

const CommunitiesScene = () => (
  <Routes>
    <Route
      path=":action?"
      element={<CommunitiesOverview menuName="Communities" />}
    />
    <Route
      path="edit/:id/:tab?/:action?/:actionId?/:view?/:viewId?/:viewPane?"
      element={<CommunityDetails menuName="Communities" />}
    />
  </Routes>
);

export default CommunitiesScene;
